const replaceWhiteSpaces = (text: string, replaceValue = "") => {
  return text?.replace(/\s/g, replaceValue);
};
export default replaceWhiteSpaces;
